export default __webpack_public_path__ + "static/media/sunset_contrasts.d6952ab3.jpg";